<script setup lang="ts">
import { ALLanguageSelector } from '@af-lib/vue-ui';
import { computed, ref, watch } from 'vue';

import { useLocales } from '@/composables/useLocales';
import { useUserLocale } from '@/composables/useUserLocale';
import { changeLanguage, locale as activeLocale } from '@/config/i18n';

const { locales, toSupportedLocale, getLocaleByIso } = useLocales();

const languages = computed(() => [...locales.value]);

const selectedLanguage = ref(getLocaleByIso(toSupportedLocale(activeLocale.value) ?? 'en-US'));

// Here the router guard realigns the app on the account
// language (useUserLocale.syncLocaleFromUser) after app.mount(), and the header
// sits outside RouterView so it is already mounted — without this it would stay
// on the cookie language.
watch(activeLocale, iso => {
  selectedLanguage.value = getLocaleByIso(toSupportedLocale(iso) ?? 'en-US');
});

async function onChange() {
  const iso = selectedLanguage.value?.iso_code_639;
  if (!iso) return;

  await changeLanguage(iso);

  await useUserLocale().persistLocaleForUser(iso);
}
</script>

<template>
  <ALLanguageSelector v-model="selectedLanguage" :languages="languages" @update:model-value="onChange" />
</template>
